import {
  Box,
  Card,
  Chip,
  CircularProgress,
  LinearProgress,
  Typography,
  useTheme,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { clientPackageService } from '../../../shared/services';

export const HomePackages: React.FC = () => {
  const theme = useTheme();

  const { data: packages, isFetching } = useQuery({
    queryKey: ['myPackages'],
    queryFn: () => clientPackageService.getMyPackages(),
  });

  return (
    <Box>
      <Typography variant='h4' sx={{ mb: 2 }}>
        Meus Pacotes
      </Typography>

      {isFetching ? (
        <Box display='flex' justifyContent='center' py={4}>
          <CircularProgress />
        </Box>
      ) : packages && packages.length > 0 ? (
        <Box display='flex' flexDirection='column' gap={2}>
          {packages.map((pkg) => {
            const usagePct = pkg.totalUses > 0
              ? Math.round(((pkg.totalUses - pkg.remainingUses) / pkg.totalUses) * 100)
              : 0;
            const isExpired = pkg.expiresAt && new Date(pkg.expiresAt) < new Date();
            const isActive = pkg.active && !isExpired;

            return (
              <Card
                key={pkg.id}
                sx={{
                  p: 3,
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 3,
                  opacity: isActive ? 1 : 0.5,
                }}
              >
                <Box display='flex' justifyContent='space-between' alignItems='flex-start' mb={1}>
                  <Box>
                    <Typography variant='h6' fontWeight={600}>
                      {pkg.packageName}
                    </Typography>
                    <Typography variant='body2' color='text.secondary'>
                      {pkg.businessName}
                    </Typography>
                  </Box>
                  <Chip
                    label={isActive ? 'Ativo' : isExpired ? 'Expirado' : 'Inativo'}
                    size='small'
                    color={isActive ? 'success' : 'default'}
                    variant='outlined'
                  />
                </Box>

                <Box mt={2} mb={1}>
                  <Box display='flex' justifyContent='space-between' mb={0.5}>
                    <Typography variant='body2' color='text.secondary'>
                      Usos: {pkg.remainingUses}/{pkg.totalUses}
                    </Typography>
                    <Typography variant='body2' color='text.secondary'>
                      {usagePct}%
                    </Typography>
                  </Box>
                  <LinearProgress
                    variant='determinate'
                    value={usagePct}
                    sx={{
                      height: 8,
                      borderRadius: 4,
                      backgroundColor: theme.palette.action.hover,
                      '& .MuiLinearProgress-bar': {
                        borderRadius: 4,
                        backgroundColor: usagePct >= 80
                          ? theme.palette.warning.main
                          : theme.palette.primary.main,
                      },
                    }}
                  />
                </Box>

                <Box display='flex' flexWrap='wrap' gap={0.5} mt={1}>
                  <Chip label={pkg.serviceName} size='small' variant='outlined' />
                </Box>

                {pkg.expiresAt && (
                  <Typography variant='caption' color='text.secondary' display='block' mt={1}>
                    Válido até: {new Date(pkg.expiresAt).toLocaleDateString('pt-BR')}
                  </Typography>
                )}
                <Typography variant='caption' color='text.secondary' display='block'>
                  Adquirido em: {new Date(pkg.purchasedAt).toLocaleDateString('pt-BR')}
                </Typography>
              </Card>
            );
          })}
        </Box>
      ) : (
        <Box display='flex' justifyContent='center' py={4}>
          <Typography color='text.secondary'>
            Você ainda não possui pacotes.
          </Typography>
        </Box>
      )}
    </Box>
  );
};
